<style lang="css">
@import '../css/bootstrap.css';
@import '../css/bootstrap-vue.css';
@import '../css/admin-table.css';
</style>
<style lang="scss" scoped>
@import '../css/admin.scss';
</style>
<template>
  <div class="admin-page">
    <admin-header :tit="this.title"></admin-header>
    <admin-side></admin-side>
    <section class="admin-template">
      <h2 class="sub-tit">공지사항 관리</h2>
      <div class="contents">
        <b-container fluid>
          <!-- User Interface controls -->
            <b-row>
             <b-col class="my-1 text-left type-box">
               <b-form-group
                label="사용여부"
                label-for="form-select"
                label-cols-sm="3"
                label-align-sm="left"
                label-size="sm"
                class="mb-0 "
              >
               <b-form-select size="sm" class="item-select" v-model="itemSelected" :options="itemOptions"></b-form-select>
              </b-form-group>
            </b-col>
            <b-col class="my-1 text-left type-box">
               <b-form-group
                label="공지타입"
                label-for="form-select"
                label-cols-sm="3"
                label-align-sm="left"
                label-size="sm"
                class="mb-0 "
              >
               <b-form-select size="sm" class="item-select" v-model="typeSelected" :options="typeOptions"></b-form-select>
              </b-form-group>
            </b-col>
            <b-col class="my-1 filter-box notice-search-area">
              <b-form-group
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-input
                    id="filter-input"
                    type="search"
                    placeholder="공지사항 제목을 입력해 주세요."
                    v-model="searchText"
                  ></b-form-input>
                  <b-button size="sm" @click="itemFilter()" class="search-btn">검색</b-button>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <!-- Main table element -->
          <b-table
            id="expert-management"
            :items="items"
            :fields="fields"
            stacked="md"
            show-empty
            small
          >
            <template #cell(useYn)="row">
              {{ row.value }}
            </template>
            <template #cell(idNotice)="row">
              {{ row.value }}
            </template>
            <template #cell(CodeNm)="row">
              {{ row.value }}
            </template>
            <template #cell(titleNotice)="row">
              {{ row.value }}
            </template>
            <template #cell(IYmd)="row">
              {{ row.value }}
            </template>
            <template #cell(actions)="row">
              <b-button size="sm" @click="modifyWrite(row.item, row.index)" class="save-btn mr-1">수정</b-button>
              <b-button size="sm" @click="deleteItem(row.item, row.index)" class="deleat-btn">삭제</b-button>
            </template>
          </b-table>
          <b-row>
            <b-col lg="12" class="my-1 text-right">
              <b-button variant="primary" class="new-item-btn" @click="newWrite()">등록</b-button>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <b-modal
          id="new-write"
          class="item-modal"
          size="lg"
          title="공지사항 등록하기"
          @show="resetModal"
          @hidden="resetModal"
          >
            <b-row class="modal-top-row">
              <b-col sm="7" class="my-1 modal-top-area">
                <div class="my-1 text-left modal-top-left">
                  <label>공지번호</label>
                  <b-form-input
                    v-model="noticeModal.selectNum"
                    disabled
                  ></b-form-input>
                </div>
                <div class="my-1 text-left modal-top-center">
                  <label>사용여부</label>
                  <b-form-select size="sm" class="item-select" v-model="noticeModal.whetherSelected" :options="noticeModal.whether"></b-form-select>
               </div>
              </b-col>
              <b-col sm="5" class="my-1">
                <div class="my-1 modal-top-right">
                  <label>공지타입</label>
                  <b-form-select size="sm" class="item-select" v-model="noticeModal.typeSelected" :options="noticeModal.type"></b-form-select>
                </div>
              </b-col>
              <b-col class="my-1 text-left type-box footer-command-box" sm="12">
                <label>공지 제목(Q&A 질의)</label>
                <b-form-input class="footer-command" v-model="noticeModal.titleNotice"></b-form-input>
              </b-col>
            </b-row>
          <template #modal-footer class="modify-footer-area">
            <quill-editor
            ref="newWriteEditor"
            v-model="noticeModal.editorContent"
            :options="noticeModal.editorOption"
            @blur="onEditorBlur($event)"
            @focus="onEditorFocus($event)"
            @ready="onEditorReady($event)"
          />
            <b-col class="my-1 text-right type-box new-command-box" sm="12">
              <div class="right-column">
                <b-button
                variant="primary"
                size="sm"
                @click="writeSave()"
              >
                등록
              </b-button>
              </div>
            </b-col>
          </template>
        </b-modal>
        <b-modal
          id="modify-write"
          class="item-modal"
          size="lg"
          title="공지사항 수정하기"
          @show="resetModal"
          @hidden="resetModal"
          >
            <b-row class="modal-top-row">
              <b-col sm="7" class="my-1 modal-top-area">
                <div class="my-1 text-left modal-top-left">
                  <label>공지번호</label>
                  <b-form-input
                    v-model="noticeModal.selectNum"
                    disabled
                  ></b-form-input>
                </div>
                <div class="my-1 text-left modal-top-center">
                  <label>사용여부</label>
                  <b-form-select size="sm" class="item-select" v-model="noticeModal.whetherSelected" :options="noticeModal.whether"></b-form-select>
               </div>
              </b-col>
              <b-col sm="5" class="my-1">
                <div class="my-1 modal-top-right">
                  <label>공지타입</label>
                  <b-form-select size="sm" class="item-select" v-model="noticeModal.typeSelected" :options="noticeModal.type"></b-form-select>
                </div>
              </b-col>
              <b-col class="my-1 text-left type-box footer-command-box" sm="12">
                <label>공지 제목(Q&A 질의)</label>
                <b-form-input class="footer-command" v-model="noticeModal.titleNotice"></b-form-input>
              </b-col>
            </b-row>
          <template #modal-footer class="modify-footer-area">
            <quill-editor
            ref="modifyWriteEditor"
            v-model="noticeModal.editorContent"
            :options="noticeModal.editorOption"
            @blur="onEditorBlur($event)"
            @focus="onEditorFocus($event)"
            @ready="onEditorReady($event)"
          />
            <b-col class="my-1 text-right type-box new-command-box" sm="12">
              <div class="right-column">
                <b-button
                variant="primary"
                size="sm"
                @click="modifySave()"
              >
                수정
              </b-button>
              </div>
            </b-col>
          </template>
        </b-modal>
    </section>
  </div>
</template>
<script>
import AdminHeader from '@/components/AdminHeader'
import AdminSide from '@/components/AdminSide'

import { mapGetters } from 'vuex'

export default {
  name: 'AdminNotice',
  components: {
    'admin-header': AdminHeader,
    'admin-side': AdminSide
  },
  data () {
    return {
      title: '관리자 페이지',
      layerPopPost: false,
      itemSelected: '',
      typeSelected: '',
      addressCitySelected: '0',
      itemOptions: [
        { value: '', text: '전체' },
        { value: 'Y', text: '사용' },
        { value: 'N', text: '미사용' }
      ],
      typeOptions: [
        { value: '', text: '전체' }
      ],
      searchText: '',
      /* items: [
        { status: '사용', number: '1', type: '중요', tit: '안심매물관리규정 및 관련 정책개정안내(2019.11.12)', date: '2020.03.08' },
        { status: '사용', number: '2', type: '중요', tit: '안심매물관리규정 및 관련 정책개정안내(2019.11.12)', date: '2020.03.08' },
        { status: '사용', number: '3', type: '중요', tit: '안심매물관리규정 및 관련 정책개정안내(2019.11.12)', date: '2020.03.08' },
        { status: '사용', number: '4', type: '중요', tit: '안심매물관리규정 및 관련 정책개정안내(2019.11.12)', date: '2020.03.08' },
        { status: '사용', number: '5', type: '중요', tit: '안심매물관리규정 및 관련 정책개정안내(2019.11.12)', date: '2020.03.08' },
        { status: '사용', number: '6', type: '중요', tit: '안심매물관리규정 및 관련 정책개정안내(2019.11.12)', date: '2020.03.08' },
        { status: '사용', number: '7', type: '중요', tit: '안심매물관리규정 및 관련 정책개정안내(2019.11.12)', date: '2020.03.08' }
      ], */
      fields: [
        { key: 'useYn', label: '사용 여부', class: 'text-center' },
        { key: 'idNotice', label: '공지 번호', class: 'text-center' },
        { key: 'CodeNm', label: '공지 타입', class: 'text-center' },
        { key: 'titleNotice', label: '공지 제목', class: 'text-center' },
        { key: 'IYmd', label: '공지 등록일', class: 'text-center' },
        { key: 'actions', label: '', class: 'text-center' }
      ],
      noticeModal: {
        title: '전문가 추천',
        selectNum: '01',
        whetherSelected: 'Y',
        typeSelected: '',
        whether: [
          { value: 'Y', text: '사용' },
          { value: 'N', text: '미사용' }
        ],
        titleNotice: '',
        type: [
          /* { value: '0', text: '일반' },
          { value: '0', text: '중요' } */
        ]
      },
      editorContent: '<h2>내용 입력</h2>',
      editorOption: {
        // Some Quill options...
      }
    }
  },
  created () {
    this.initNoticeCode()
  },
  watch: {
    typeNotices () {
      this.noticeModal.type = []
      for (var i = 0; i < this.typeNotices.length; i++) {
        // console.log(this.typeNotices[i])
        let tmp = { value: this.typeNotices[i].deCode, text: this.typeNotices[i].codeNm }
        this.typeOptions.push(tmp)
        this.noticeModal.type.push(tmp)
      }
      this.typeSelected = this.typeOptions[0].value
      this.noticeModal.typeSelected = this.noticeModal.type[0].value
      this.searchNotice()
    }
  },
  methods: {
    initNoticeCode () {
      this.$store.dispatch('apiEtcCodelists', {'Code': '003', 'DeCode': ''})
    },
    searchNotice () {
      this.$store.dispatch('apiNoticeList', {'clNotice': this.typeSelected, 'useYn': this.itemSelected, 'titleNotice': this.searchText})
    },
    newWrite () {
      this.noticeModal.title = '공지 등록하기'
      this.noticeModal.selectNum = '신규'
      this.noticeModal.whetherSelected = 'Y'
      this.noticeModal.typeSelected = this.noticeModal.type[0].value
      this.noticeModal.titleNotice = ''
      this.noticeModal.editorContent = '<h2>내용 입력</h2>'
      this.noticeModal.editorOption = {}
      this.$root.$emit('bv::show::modal', 'new-write')
    },
    modifyWrite (item, index) {
      this.noticeModal.title = '공지 수정하기'
      this.noticeModal.selectNum = item.idNotice
      this.noticeModal.whetherSelected = (item.useYn === '사용' ? 'Y' : 'N')
      this.noticeModal.typeSelected = item.clNotice
      this.noticeModal.titleNotice = item.titleNotice
      this.noticeModal.editorContent = item.descNotice
      this.noticeModal.editorOption = {}
      // console.log('item = ' + item.clNotice)
      this.$root.$emit('bv::show::modal', 'modify-write')
    },
    writeSave () {
      let str = this.tranSaveVaild()
      if (str === 'success') {
        this.saveNotice('I', this.noticeModal)
      } else {
        alert(str)
      }
      /* alert('저장')
      this.$nextTick(() => {
        this.$bvModal.hide('new-write')
      }) */
    },
    modifySave () {
      let str = this.tranSaveVaild()
      if (str === 'success') {
        this.saveNotice('U', this.noticeModal)
      } else {
        alert(str)
      }
      /* alert('수정완료')
      this.$nextTick(() => {
        this.$bvModal.hide('modify-write')
      }) */
    },
    saveNotice (type, obj) {
      const params = {
        'clNotice': obj.typeSelected,
        'titleNotice': obj.titleNotice,
        'descNotice': obj.editorContent,
        'useYN': obj.whetherSelected,
        'idNotice': (obj.selectNum === '신규' ? '' : obj.selectNum),
        'flag': type
      }
      // console.log('param = ' + params)
      this.$store.dispatch('apiTranNotice', params).then(() => {
        // console.log('this.tranNoticeRtn = ' + this.tranNoticeRtn)
        if (this.tranNoticeRtn !== 'fail') {
          if (type === 'I') {
            alert('저장')
            this.$nextTick(() => {
              this.$bvModal.hide('new-write')
            })
          } else if (type === 'U') {
            alert('수정완료')
            this.$nextTick(() => {
              this.$bvModal.hide('modify-write')
            })
          } else {
            alert('삭제')
          }
          this.searchNotice()
        } else {
          alert('내용 변경에 실패하였습니다.')
        }
      })
    },
    tranSaveVaild () {
      if (this.noticeModal.titleNotice === '') {
        return '공지 제목을 입력하세요.'
      }
      if (this.noticeModal.editorContent === '') {
        return '공지 내용을 입력하세요.'
      }
      return 'success'
    },
    itemFilter () {
      alert('itemFilter')
    },
    deleteItem (item, index) {
      const deleteConfirm = confirm('정말 삭제하시겠습니까??')
      if (deleteConfirm === true) {
        const params = {
          'typeSelected': item.clNotice,
          'titleNotice': item.titleNotice,
          'editorContent': item.descNotice,
          'whetherSelected': (item.useYn === '사용' ? 'Y' : 'N'),
          'selectNum': item.idNotice
        }
        this.saveNotice('D', params)
      } else {
        return false
      }
    },
    resetModal () {
      // alert('resetModal')
    },
    onEditorBlur (quill) {
      // console.log('editor blur!', quill)
    },
    onEditorFocus (quill) {
      // console.log('editor focus!', quill)
    },
    onEditorReady (quill) {
      // console.log('editor ready!', quill)
    },
    onKeyUp (quill) {
      alert('keyup')
    }
  },
  computed: {
    ...mapGetters({
      typeNotices: 'getEtcCodeList',
      items: 'getNoticeList',
      tranNoticeRtn: 'getTranNotice'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/admin/AdminNotice.vue